// Card component styles from Figma
@use '../../../styles/variables' as *;

.card {
  background: #ffffff;
  border-radius: $radius-xl;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &--backdrop {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
  }
}
